<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">部所詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_DIVISION_NEW>{{
          $t("app.buttons.save")
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                :disabled="$route.path.indexOf('new') === -1"
                :rules="companyRules"
                label="所属企業"
                url="companies/kv"
                v-model="form.companyId"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <v-select
                :items="types"
                :rules="typeRules"
                auto
                clearable
                item-text="name"
                item-value="code"
                label="部所階層"
                v-model.trim="form.type"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                label="所属事業本部"
                v-if="form.type !== 'BU'"
                :disabled="!form.type || form.type === 'BU'"
                clearable
                v-model="form.buId"
                url="/divisions/kv?type=BU"
              >
              </remote-autocomplete>
            </v-flex>
          </v-layout>
          <!-- <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                label="所属BU"
                v-if="form.type !== 'BU'"
                :disabled="form.type !== 'DEPARTMENT'"
                clearable
                v-model="form.businessUnitId"
                url="/divisions/kv?type=BUSINESS_UNIT"
              >
              </remote-autocomplete>
            </v-flex>
          </v-layout> -->
          <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :rules="codeRules"
                :disabled="!!edit"
                clearable
                label="部所CD"
                v-model.trim="form.code"
              />
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :rules="nameRules"
                clearable
                label="部所名"
                v-model="form.name"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <v-checkbox
                v-if="form.type === 'BU'"
                label="BUあり"
                v-model="form.careBu"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
import RemoteAutocomplete from "../../components/RemoteAutocomplete.vue";
export default {
  data() {
    return {
      valid: true,
      types: [
        { code: "BU", name: "事業本部" },
        { code: "BUSINESS_UNIT", name: "BU" },
        { code: "DEPARTMENT", name: "事業部" },
      ],
      BUs: [],
      form: {
        code: "",
        name: "",
        type: "",
        company: {},
        bu: null,
      },
      companyRules: [(v) => !!v || "所属企業 is required"],
      codeRules: [(v) => !!v || "部所CD is required"],
      typeRules: [(v) => !!v || "部所階層 is required"],
      nameRules: [(v) => !!v || "部所名 is required"],
      errors: {
        DUPLICATE_DIVISION: "部所重复",
      },
    };
  },
  watch: {
    "form.type": function (val) {
      if (!this.form.buId) {
        this.$set(this.form, "buId", null);
      }
      this.$set(this.form, "businessUnitId", null);
    },
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    save() {
      this.$http
        .post("/divisions", this.form)
        .then(() => {
          this.$http
            .post("purchase-orders/po-bu", this.form)
            .then(() => this.$router.go(-1));
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
  },
  mounted() {},
};
</script>
